import React from 'react';
import { useTranslation } from 'react-i18next';

export default function ViewCustomerModal({ customer, isOpen, onClose }) {
  const { t } = useTranslation('Customer');
  return (
    <div
      className="modal fade"
      id="customer-detail"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
      tabIndex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5" id="staticBackdropLabel">
              {t('VIEWCUSTOMERDETAILS')}
            </h1>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <div className="product-inner">
              <ul>
                <li>
                  <p>{t('CUSTOMERGROUPCODENAME')}</p>
                  <span>-</span>
                  <h3>
                    {' '}
                    {customer?.customer_group?.code || ''}{' '}
                    <span className="px-3">/</span>
                    {customer?.customer_group?.group || ''}
                  </h3>
                </li>
                <li>
                  <p>{t('CUSTOMERCODENAMEEMAIL')}</p>
                  <span>-</span>
                  <h3>
                    {' '}
                    {customer?.code || ''}
                    <span className="px-3">/</span> {customer?.name || ''}{' '}
                    <span className="px-3">/</span> {customer?.email || ''}
                  </h3>
                </li>
                <li>
                  <p>{t('DELIVERYADDRESS')}</p>
                  <span>-</span>
                  <h3>{customer?.delivery_address || ''}</h3>
                </li>
                <li>
                  <p>{t('CONTACTPERSONINFO')}</p>
                  <span>-</span>
                  <h3>
                    {' '}
                    {customer?.contact_name || ''}{' '}
                    <span className="px-3">/</span>{' '}
                    {customer?.contact_phone || ''}
                  </h3>
                </li>
                <li>
                  <p>{t('DISTRICT')}</p>
                  <span>-</span>
                  <h3>{customer?.district?.name}</h3>
                </li>
                <li>
                  <p>{t('LOGISTICLINE')}</p>
                  <span>-</span>
                  <h3>{customer?.logistic_line?.name}</h3>
                </li>
                <li>
                  <p>{t('PAYMENTMETHOD')}</p>
                  <span>-</span>
                  <h3>{customer?.payment_method?.name}</h3>
                </li>
                <li>
                  <p>{t('EARLIESTDELIVERYTIME')}</p>
                  <span>-</span>
                  <h3>{customer.earliest_delivery_time || ''}</h3>
                </li>
                <li>
                  <p>{t('LATESTDELIVERYTIME')}</p>
                  <span>-</span>
                  <h3>{customer.latest_delivery_time || ''}</h3>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
